import { FC, RefObject } from 'react'
import { Text, TextProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type DescriptionProps = TextProps &
    UnistylesVariants<typeof stylesheet> & { ref?: RefObject<Text | null> }

const Description: FC<DescriptionProps> = ({
    children,
    size = 'normal',
    font = 'regular',
    style,
    ref,
    ...props
}) => {
    const { styles } = useStyles(stylesheet, { size, font })

    return (
        <Text {...props} style={[styles.description, style]} ref={ref}>
            {children}
        </Text>
    )
}

const stylesheet = createStyleSheet((theme) => ({
    description: {
        variants: {
            size: {
                large: {
                    fontSize: 16,
                },
                normal: {
                    fontSize: 14,
                },
                small: {
                    fontSize: 12,
                },
                tiny: {
                    fontSize: 10,
                },
            },
            font: {
                bold: {
                    fontFamily: theme.fonts.bold,
                },
                medium: {
                    fontFamily: theme.fonts.medium,
                },
                regular: {
                    fontFamily: theme.fonts.regular,
                },
            },
        },
    },
}))

export default Description
